import { render, staticRenderFns } from "./image720.vue?vue&type=template&id=ba864c5c&scoped=true"
import script from "./image720.vue?vue&type=script&lang=js"
export * from "./image720.vue?vue&type=script&lang=js"
import style0 from "./image720.vue?vue&type=style&index=0&id=ba864c5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba864c5c",
  null
  
)

export default component.exports